import { createStorageAtomFactory, dedupe, withSerialization } from '@exodus/atoms';
import { mapValues } from '@exodus/basic-utils';
import lodash from 'lodash';
import { WalletAccount } from '@exodus/models';
const { isEmpty } = lodash;
export default function createWalletAccountsInternalAtom({ storage, }) {
    const atomFactory = createStorageAtomFactory({ storage });
    const walletAccountsAtom = atomFactory({
        key: 'walletAccounts',
        isSoleWriter: true,
    });
    const deserialize = (input) => {
        if (!input || isEmpty(input)) {
            return;
        }
        const walletAccounts = mapValues(input, (data) => new WalletAccount(data));
        const sortedWalletAccounts = Object.entries(walletAccounts).sort(([, a], [, b]) => {
            return Number(a.isHardware) - Number(b.isHardware);
        });
        return Object.fromEntries(sortedWalletAccounts);
    };
    const serialize = (input) => {
        if (!input || isEmpty(input)) {
            return;
        }
        return mapValues(input, (data) => data.toJSON());
    };
    return dedupe(withSerialization({
        atom: walletAccountsAtom,
        serialize,
        deserialize,
    }));
}
